/**
 * Wallet-local storage — mirrors the mobile app's expo-secure-store usage.
 * Consumer-facing screens don't require server auth for the MVP.
 * Everything is scoped to `altara.wallet.*` keys.
 */
const K = "altara.wallet.v1";

export function loadWallet() {
  try {
    const raw = localStorage.getItem(K);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveWallet(state) {
  try { localStorage.setItem(K, JSON.stringify(state)); } catch { /* ignore */ }
}

export function updateWallet(patch) {
  const current = loadWallet() || {};
  const next = { ...current, ...patch, updated_at: new Date().toISOString() };
  saveWallet(next);
  return next;
}

/**
 * Track a banker-pushed journey token this device has opened. Keeps a
 * dedup'd list so the wallet home can show every product awaiting review.
 * Tokens are HMAC-signed; the backend verifies them per request.
 */
export function registerJourneyToken(token, meta = {}) {
  if (!token) return;
  const w = loadWallet() || {};
  const list = Array.isArray(w.journey_tokens) ? [...w.journey_tokens] : [];
  const idx = list.findIndex(t => (typeof t === "string" ? t : t.token) === token);
  const entry = { token, opened_at: new Date().toISOString(), ...meta };
  if (idx >= 0) list[idx] = { ...list[idx], ...entry };
  else list.push(entry);
  saveWallet({ ...w, journey_tokens: list.slice(-25), updated_at: new Date().toISOString() });
}

export function listJourneyTokens() {
  const w = loadWallet() || {};
  return (w.journey_tokens || [])
    .map(t => (typeof t === "string" ? { token: t } : t))
    .filter(x => x && x.token);
}


export function clearWallet() {
  try { localStorage.removeItem(K); } catch { /* ignore */ }
}
